import { CustomMedia } from '@gsc/types'
import { resolveMedia } from './resolve-media'

// TODO: LRU cache ?
const queryCache = new Map<string, MediaQueryList>()

const _matchMedia = (query: string) => {
  return window.matchMedia(query.replace(/@media\s*/gi, ''))
}

export function matchMedia(query: string, customMedia: CustomMedia = {}): MediaQueryList {
  const q = resolveMedia(query, customMedia)
  if (!queryCache.has(q)) {
    queryCache.set(q, _matchMedia(q))
  }
  return queryCache.get(q)
}
